import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest,
  HttpHeaders, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs'; // ✅ use throwError
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { LoginService } from 'app/services/login.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  constructor(private loginService: LoginService) {}

  addTokenToRequest(req: HttpRequest<any>, token: string) {
    return req.clone({
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`
      })
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');

    const apiRequest = req.clone({
      url: `${environment.API_BASE}/${req.url}`
    });

    const modifiedRequest = this.addTokenToRequest(apiRequest, token);

    return next.handle(modifiedRequest).pipe(
      catchError((error: any) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          return this.loginService.refreshToken().pipe(
            switchMap((newToken: string) => {
              const newReq = this.addTokenToRequest(modifiedRequest, newToken);
              return next.handle(newReq);
            })
          );
        }
        return throwError(() => error); // ✅ RxJS 7+ preferred form
      })
    );
  }
}
